import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import React, { useState, useEffect } from "react";
import { Container, Card, Col, Row, Collapse } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import PhoneIcon from "/public/site-assets/svg/phone.svg";
import GeoLocation from "/public/site-assets/svg/geo-location.svg";
import Mail from "/public/site-assets/svg/mail.svg";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useRouter } from 'next/router';

export default function AllLocations({
    all_locations,
    all_region_locations,
    customClass = "",
}) {
    const router = useRouter();

    let [activeRegionIndex, setRegion] = useState(0);
    let [activeCityIndex, setCity] = useState(0);

    useEffect(() => {
        if (!router.isReady) return;
        const { query } = router;
        if (query && query?.region && query?.city) {
            let activeRegionId = all_region_locations?.find((region) => region.url_slug === query?.region)?.id;
            let activeRegionIndex = all_region_locations?.findIndex((region) => region.url_slug === query?.region);
            let activeCityIndex = all_locations?.filter(city => (city.parent.id === activeRegionId)).findIndex((city) => city.url_slug === query?.city);
            setRegion(activeRegionIndex !== -1 ? activeRegionIndex : 0); setCity(activeCityIndex !== -1 ? activeCityIndex : 0);
        }
    }, [router.isReady]);

    return (
        all_region_locations.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <Tabs selectedIndex={activeRegionIndex} onSelect={(index) => [ setRegion(index), setCity(0) ] }>
                        <TabList className="d-flex flex-wrap justify-content-center mb-3 list-unstyled">
                            {all_region_locations.map((post, index) => (
                                <Tab
                                    key={index}
                                    className="px-3 py-2 mb-2 rounded-3 parent"
                                >
                                    <strong>{post.title}</strong>
                                </Tab>
                            ))}
                        </TabList>
                        {all_region_locations.map((region, index) => (
                            <TabPanel key={index}>
                                <Tabs selectedIndex={activeCityIndex} onSelect={(index) => setCity(index)}>
                                    <TabList>
                                        {all_locations.map((post, index) => (
                                            post.parent.identifier === region.title && (
                                                <Tab className="list-unstyled tab-wrapper p-3 rounded-3" key={index}><strong>{post.title}</strong></Tab>
                                            )
                                        ))}
                                    </TabList>
                                    {all_locations.map((post, index) => (
                                        post.parent.identifier === region.title && (
                                            <TabPanel key={index}>
                                                <div className="location p-lg-5 p-4 rounded-3">
                                                    <h3 className="mt-0 mb-4"><strong>{post.title}</strong></h3>
                                                    <Row>
                                                        {/* <Col lg={4} className="pe-md-4 mb-4 mb-lg-0">
                                                            <SourceFlowImage
                                                                src={post?.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                                                size="800x800"
                                                                alt={post.title}
                                                                className="card-img rounded-3"
                                                                width="100%"
                                                                height="100%"
                                                            />
                                                        </Col> */}
                                                        <Col lg={8} className="location-details">
                                                            {post?.address ?
                                                                <div className="post-address bg-light rounded-3 border position-relative">
                                                                    <GeoLocation />
                                                                    <strong>{post.address}</strong></div> :
                                                                ""}
                                                            {post?.telephone ?
                                                                <div className="post-telephone bg-light rounded-3 border position-relative">
                                                                    <PhoneIcon />
                                                                    <Link href={`tel:${post?.telephone}`}>
                                                                        <a className="text-decoration-none">
                                                                            <strong>{post.telephone}</strong>
                                                                        </a>
                                                                    </Link>
                                                                </div> :
                                                                ""}
                                                            {post?.email ?
                                                                <div className="post-email bg-light rounded-3 border position-relative">
                                                                    <Mail />
                                                                    <Link href={`mailto:${post?.email}`}>
                                                                        <a className="text-decoration-none">
                                                                            <strong>{post.email}</strong>
                                                                        </a>
                                                                    </Link>
                                                                </div> :
                                                                ""}
                                                        </Col>
                                                        {post?.map_embed ?
                                                            <div className="mt-4 rounded-3 overflow-hidden">
                                                                <div dangerouslySetInnerHTML={{ __html: post?.map_embed }} />
                                                            </div>
                                                            : ""}
                                                    </Row>
                                                </div>
                                            </TabPanel>
                                        )
                                    ))}
                                </Tabs>
                            </TabPanel>
                        ))}
                    </Tabs>
                </Container>
            </section>
        )
    );
}